import { Box, Divider, Grid, Typography } from "@mui/material";
import React from "react";

type HeaderProps = {
    title?: string,
    image?: React.ReactNode | null,
    description?: string,
    element?: React.ReactNode | null;
    chat?: React.ReactNode | null;
    config?: React.ReactNode | null;
    user?: React.ReactNode | null;
    wallet?: React.ReactNode | null;
    store?: React.ReactNode | null;
    docs?: React.ReactNode | null;
    clothes?: React.ReactNode | null;
};

export const HeaderComponent : React.FC<HeaderProps> = ({title,image,description,element,chat,config,user,wallet,store,docs,clothes}) => {
    return (
        <div>
            <Box sx={{width:"100%", height:"350px"}}>
                <Grid 
                container 
                direction={"row"} 
                justifyContent={"center"} 
                alignItems={"center"} 
                sx={{height:"100%"}}>
                    <Grid item xs={5}>
                        <Grid 
                        container 
                        direction={"column"} 
                        justifyContent={"center"} 
                        alignItems={"center"} 
                        sx={{height:"100%"}}>
                            <Grid item>
                                <Typography variant="h1">{title}</Typography>
                                {image !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{image}</Grid>}
                            </Grid>
                            <Grid item sx={{mt:2}}>
                            <Typography>{description}</Typography>
                            </Grid>
                            <Grid container direction={"row"}>
                            {element !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{element}</Grid>}
                            {chat !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{chat}</Grid>}
                            {config !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{config}</Grid>}
                            {user !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{user}</Grid>}
                            {wallet !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{wallet}</Grid>}
                            {store !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{store}</Grid>}
                            {docs !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{docs}</Grid>}
                            {clothes !== undefined && <Grid sx={{mt:4, width:"100%"}} item>{clothes}</Grid>}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            
        </div>
    );
};